import React, { useRef, useEffect } from "react";
import styles from "./LayoutWithLog.module.css";

interface ComponentProp extends Prop {
  logMessages: string[];
}

interface Prop {
  style?: any;
  children?: string | JSX.Element | JSX.Element[];
}

function LayoutWithLog({ logMessages, style, children }: ComponentProp) {
  const divRef = useRef(null);

  useEffect(() => {
    (divRef.current as any)?.scrollIntoView({ behavior: "smooth" });
  });

  return (
    <div className={styles["content-container"]}>
      {children}
      <div className={styles["log-view"]}>
        <div className={styles["label"]}>Log</div>
        <div className={styles["log-box"]}>
          {logMessages.map((m) => (
            <p>{m}</p>
          ))}
          <div style={{ float: "left", clear: "both" }} ref={divRef}></div>
        </div>
      </div>
    </div>
  );
}

function Content({ style, children }: Prop) {
  return (
    <div className={styles["content"]} style={style}>
      {children}
    </div>
  );
}

LayoutWithLog.Content = Content;
export default LayoutWithLog;
